import React, { useEffect } from 'react';
import { AppRouter } from './routes';
import { useAppState } from './hooks/use-app-state.hook';
import SiteWrapper from './components/layout/site-wrapper/site-wrapper.component';
import SiteHeader from './components/layout/site-header/site-header.component';
import SiteContent from './components/layout/site-content/site-content.component';
import SiteFooter from './components/layout/site-footer/site-footer.component';
import Page from './components/layout/page/page.component';
import Spinner from './components/layout/spinner/spinner.component';
import Button from './components/layout/button/button.component';
import ReactTooltip from 'react-tooltip';
import { useLocation } from 'react-router-dom';
import { useLoadData } from './hooks/use-load-data.hook';

function App() {
    const [{
        dataReady
    }] = useAppState();
    const { pathname } = useLocation();

    const { hasError, retry } = useLoadData();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <SiteWrapper>
            { dataReady ? (
                <>
                    <SiteHeader/>
                    <SiteContent>
                        <AppRouter/>
                    </SiteContent>
                </>
            ) : (
                <Page vCentered>
                    { hasError ? (
                        <div>
                            <p role='alert'>Unable to load data. Please try again.</p>
                            <Button onClick={ retry }>Retry</Button>
                        </div>
                    ) : <Spinner/> }
                </Page>
            ) }
            <SiteFooter/>
            <ReactTooltip
                effect='solid'
                multiline={ true }
                delayShow={ 300 }
                place='right'
                className='app-tooltip'/>
        </SiteWrapper>
    );
}

export default App;
